<template>
  <div class="component-box">
    <div class="dialog-box">
      <div class="dialog-header">
        <p>访问{{ shopOrStudioTag }}</p>
        <i class="el-icon-close" @click="close()"></i>
      </div>
      <div class="dialog-body">
        <div class="PC-channel">
          <p>PC端</p>
          <a
            :href="`//shop.xkw.com/${shopId}`"
            target="_blank"
            class="to-index-btn"
            name="go_pc_shop"
            >前往PC端{{ shopOrStudioTag }}</a
          >
          <div class="bottom-link">
            <span
              @click="copyLink(`https://shop.xkw.com/${shopId}`)"
              data-io-click="tracker"
              name="copy_link_1"
              >复制链接</span
            >
          </div>
        </div>
        <div class="WX-channel">
          <p>小程序端</p>
          <div class="code-box">
            <img
              v-show="WXMiniCodeUrl"
              :src="WXMiniCodeUrl"
              alt=""
              class="code"
            />
            <div
              class="download-bg"
              @click="downloadCode(WXMiniCodeUrl, '小程序二维码.png')"
              data-io-click="tracker"
              name="down_qr_code_1"
            >
              <img
                src="../../assets/images/download-code-icon.png"
                alt=""
                class="download-code-icon"
              />
            </div>
          </div>
          <div class="bottom-link">
            <span
              @click="copyLink(WXMiniUrl)"
              data-io-click="tracker"
              name="copy_link_2"
              >复制链接</span
            >
            <span
              @click="downloadPoster(1)"
              data-io-click="tracker"
              name="down_poster_1"
              >下载海报</span
            >
          </div>
        </div>
        <div class="H5-channel">
          <p>H5端</p>
          <div class="code-box">
            <VueQr
              :text="`https://m.zxxk.com/knowledgeStore/home/${shopId}`"
              :logoSrc="this.shopInfo.logoPath"
              :size="270"
              :logoScale="0.3"
              :logoMargin="4"
              :correctLevel="3"
              :margin="10"
              class="code"
              :callback="setH5CodeUrl"
            ></VueQr>
            <div
              class="download-bg"
              @click="downloadCode(H5CodeUrl, 'H5二维码.png')"
              data-io-click="tracker"
              name="down_qr_code_2"
            >
              <img
                src="../../assets/images/download-code-icon.png"
                alt=""
                class="download-code-icon"
              />
            </div>
          </div>
          <div class="bottom-link">
            <span
              @click="
                copyLink(`https://m.zxxk.com/knowledgeStore/home/${shopId}`)
              "
              data-io-click="tracker"
              name="copy_link_3"
              >复制链接</span
            >
            <span
              @click="downloadPoster(2)"
              data-io-click="tracker"
              name="down_poster_2"
              >下载海报</span
            >
          </div>
        </div>
      </div>
    </div>
    <storePoster
      :storeInfo="shopInfo"
      :posterType="posterType"
      :WXMiniCodeUrl="WXMiniCodeUrl"
      :H5CodeUrl="H5CodeUrl"
      id="poster"
    ></storePoster>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import html2canvas from "html2canvas";
import api from "@/assets/js/api";
import { jsonp, copyContent, download } from "../../assets/js/utils";
import storePoster from "./store-poster.vue";
export default {
  name: "ShopCenterAdminWebStoreShareDialog",
  components: {
    VueQr,
    storePoster,
  },
  data() {
    return {
      shopInfo: {},
      WXMiniCodeUrl: "",
      WXMiniUrl: "",
      H5CodeUrl: "",
      posterType: 1, // 1-小程序 2-H5
    };
  },
  computed: {
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
  },
  async mounted() {
    await this.getShopInfo();
    this.getWXMiniCode();
    this.getWxMiniUrl();
  },

  methods: {
    // 关闭弹窗
    close() {
      this.$emit("closeDialog");
    },
    // 复制链接
    async copyLink(link) {
      const res = await copyContent(link);
      if (res) {
        this.$message({
          message: "复制成功",
          type: "success",
          customClass: "dialog-message",
        });
      } else {
        this.$message({
          message: "复制失败",
          type: "error",
          customClass: "dialog-message",
        });
      }
    },
    // 获取微信小程序二维码
    getWXMiniCode() {
      // 这个地方去获取小程序店铺的二维码
      jsonp(
        "https://wxmini.zxxk.com/api/common/getminicode?path=packages/knowledgeStore/pages/detail/index",
        {
          storeId: this.shopId,
          SessionKey: "shop",
          logo: this.shopInfo.logoPath,
        },
        (res) => {
          this.WXMiniCodeUrl = "https://img.zxxk.com/wxmini" + res.Data;
        }
      );
    },
    // 获取微信小程序链接
    async getWxMiniUrl() {
      if (process.env.NODE_ENV == "production") {
        const res = await this.$axios.post(api.info.getWXMiniUrl, {
          shopId: this.shopId,
        });
        this.WXMiniUrl = res.result;
      } else {
        this.WXMiniUrl = "测试环境不允许复制小程序链接，请在线上验证~";
      }
    },
    // 获取店铺信息
    async getShopInfo() {
      const res = await this.$axios.post(
        api.info.getShopInfo + "?shopId=" + this.shopId
      );
      this.shopInfo = res.result;
      // 将店铺信息存到Vuex中
      this.$store.commit("store/setStoreInfo", this.shopInfo);
    },
    // 下载二维码
    downloadCode(imgUrl, imgName) {
      download(imgUrl, imgName);
    },
    // 保存二维码图片地址
    setH5CodeUrl(dataUrl) {
      this.H5CodeUrl = dataUrl;
    },
    // 下载海报
    downloadPoster(type) {
      this.posterType = type;
      this.$nextTick(() => {
        const el = document.getElementById("poster");
        html2canvas(el, {
          tainttest: true, // 检测每张图片都已经加载完成
          useCORS: true,
          onclone: (document) => {
            document.getElementById("poster").style.display = "flex";
          },
        }).then(function (canvas) {
          const imgData = canvas.toDataURL("image/png");
          download(
            imgData,
            type === 1 ? "小程序店铺海报.png" : "H5店铺海报.png"
          );
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.component-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background: rgba($color: #000000, $alpha: 0.6);
  .dialog-box {
    position: relative;
    width: 542px;
    height: 270px;
    padding: 15px 24px 10px 24px;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08),
      0px 16px 24px 2px rgba(0, 0, 0, 0.04),
      0px 6px 30px 5px rgba(0, 0, 0, 0.05);
    .dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      & > p {
        color: #595959;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
      }
      & > i {
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .dialog-body {
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        width: 172px;
        height: 180px;
        padding: 20px 0 28px;
        border-radius: 10px;
        border: 1px solid #fff;
        background: linear-gradient(
          180deg,
          #fafafa 0%,
          rgba(255, 255, 255, 0) 100%
        );
        & > p {
          color: #606266;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 14px; /* 100% */
        }
        .code-box {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 130px;
          height: 130px;
          .code {
            width: 130px;
            height: 130px;
          }
          .download-bg {
            display: none;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border-radius: 6px;
            background: rgba(0, 0, 0, 0.6);
            transition: all 0.3s ease-in-out;
            cursor: pointer;
            .download-code-icon {
              width: 17px;
              height: 18px;
            }
          }

          &:hover {
            .download-bg {
              display: flex;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 9;
            }
          }
        }
        .bottom-link {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #3d47fb;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px; /* 100% */
          cursor: pointer;
          & > span {
            padding: 0 10px;
          }
        }
      }
      .PC-channel {
        .to-index-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 7px 5px;
          color: #3d47fb;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px; /* 100% */
          border-radius: 4px;
          border: 1px solid #3d47fb;
          background: #fff;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
